import api from "./api";

/**
 * Platform yöneticisi uçları (backend: /api/admins).
 * Çağıran taraf res.data.data okur.
 */
export const adminService = {
  list: () => api.get("/admins"),
  create: (payload) => api.post("/admins", payload),
  setActive: (id, active) => api.patch(`/admins/${id}/status`, null, { params: { active } }),
};
